export enum DocumentHistoryTypes {
    GET_DOCUMENT_HISTORY_LOADING = "GET_DOCUMENT_HISTORY_LOADING",
    GET_DOCUMENT_HISTORY_SUCCESS = "GET_DOCUMENT_HISTORY_SUCCESS",
    GET_DOCUMENT_HISTORY_FAILURE = "GET_DOCUMENT_HISTORY_FAILURE",

    CREATE_DOCUMENT_HISTORY_LOADING = "CREATE_DOCUMENT_HISTORY_LOADING",
    CREATE_DOCUMENT_HISTORY_SUCCESS = "CREATE_DOCUMENT_HISTORY_SUCCESS",
    CREATE_DOCUMENT_HISTORY_FAILURE = "CREATE_DOCUMENT_HISTORY_FAILURE",
}
